export const REQUEST_API = 'api/REQUEST_API';
export const RECEIVE_API = 'api/RECEIVE_API';
export const REQUEST_AUTH = 'api/REQUEST_AUTH';
export const RECEIVE_AUTH = 'api/RECEIVE_AUTH';


